<template>
  <div class="sm:flex-row flex flex-col">
    <div class="md:px-[15%] bg-blackly flex items-center grow px-8 py-16" :class="image ? 'sm:w-2/3' : ''">
      <slot />
    </div>
    <FixedAspect v-if="image" :ratio="11 / 10" class="sm:w-1/3">
      <CldnImg v-if="image.url" :src="image.url" :alt="image.title" sizes="393px sm:605px" />
    </FixedAspect>
  </div>
</template>

<script>
import FixedAspect from '@/components/common/FixedAspect';
import CldnImg from '@/components/CldnImg';

export default defineNuxtComponent({
  components: {
    FixedAspect,
    CldnImg,
  },
  props: {
    image: {
      type: Object,
      default: null,
    },
  },
});
</script>
